<template>
    <div>
        <v-col cols="12">
            <button class="button back-to-list" @click="backToList">
                <v-icon>mdi-arrow-left</v-icon>
                <span class="text">Back To List</span>
            </button>
        </v-col>
        <v-col cols="12">
            <h2>
                {{ pageTitle }}
            </h2>
        </v-col>
        <div>
            <v-col cols="12" :class="`tabs ${!id ? 'stepper' : ''}`">
                <v-tabs
                    v-model="tab"
                    show-arrows
                    :class="`${!!errorsInTabs.find((x) => x == tab) ? 'v-tabs--error' : ''}`"
                >
                    <v-tab
                        v-for="(title, index) in stepperHeaders"
                        :key="index"
                        :class="`${!!errorsInTabs.find((x) => x == index) ? 'v-tab--error' : ''} ${
                            !!sections[index].isValid ? 'v-tab--valid' : ''
                        }`"
                        :disabled="
                            !(
                                sections[index].isValid ||
                                (sections[index - 1] && sections[index - 1].isValid) ||
                                section > index
                            ) && !id
                        "
                    >
                        <div class="tab">
                            <div class="icon-error">
                                <v-icon
                                    v-if="!!errorsInTabs.find((x) => x == index)"
                                    class="error-icon"
                                    left
                                    dense
                                    color="red"
                                    >mdi-alert</v-icon
                                >
                            </div>
                            <div class="title-wrap">{{ title }}</div>
                            <div v-if="!id" class="icon-wrap">
                                <v-icon class="wrap">icon icon-stepper</v-icon>
                                <v-icon
                                    v-if="!sections[index].isValid"
                                    :class="`${index !== sections.length - 1 ? 'step' : 'step last-step'}`"
                                    v-text="index !== sections.length - 1 ? 'mdi-chevron-right' : 'mdi-minus'"
                                ></v-icon>
                                <v-icon v-if="sections[index].isValid" class="step valid">mdi-check</v-icon>
                            </div>
                        </div>
                    </v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" :touchless="!id">
                    <v-tab-item
                        v-for="(component, index) in sections"
                        :key="index"
                        transition="scroll-x-reverse-transition"
                        reverse-transition="scroll-x-transition"
                    >
                        <v-form :ref="'test'" v-model="component.isValid">
                            <component :is="component.component" :key="index"></component>
                            <stepper-control
                                v-model="tab"
                                :is-disabled="!(component.isValid || index === sections.length - 1) && !id"
                                :last="index === sections.length - 1"
                                :hide-steps="!!!id"
                            >
                                <template v-if="index === sections.length - 1 || !!id">
                                    <pharmacy-site-actions
                                        :disabled="!!errorsInTabs.length && !id"
                                        @reloadPharmacySite="loadPharmacySite"
                                    ></pharmacy-site-actions>
                                </template>
                            </stepper-control>
                        </v-form>
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </div>
        <!-- <div class="stepper">
            <v-stepper v-model="section" elevation="0">
                <v-stepper-header>
                    <template v-for="(title, index) in stepperHeaders">
                        <v-stepper-step
                            :key="title"
                            :complete="section > index + 1"
                            :step="index + 1"
                            :editable="id ? true : section > index"
                            :rules="[
                                () => sections[index].isValid || _.values(pharmacySiteErrorMessages).every(_.isEmpty),
                            ]"
                            :class="sections[index].isValid && !id ? 'v-stepper__step--valid' : false"
                            error-icon="mdi mdi-close"
                            edit-icon="mdi mdi-check"
                        >
                            {{ title }}
                        </v-stepper-step>
                        <v-divider :key="index"></v-divider>
                    </template>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content v-for="(component, index) in sections" :key="index" :step="index + 1">
                        <v-form :ref="'pharmacy-site-form-' + index" v-model="component.isValid">
                            <stepper-control
                                v-model="section"
                                :is-disabled="!(component.isValid || index === sections.length - 1)"
                                :last="index === sections.length - 1"
                            ></stepper-control>
                            <component :is="component.component" :key="index"></component>
                        </v-form>
                    </v-stepper-content>

                    <v-progress-circular
                    v-if="loading"
                    class="d-block m-auto"
                    indeterminate
                    color="primary"
                ></v-progress-circular>
                </v-stepper-items>
            </v-stepper>
        </div> -->
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            tab: 0,
            stepperHeaders: [
                t('pharmacy-sites::stepper.title.main_details'),
                t('pharmacy-sites::stepper.title.chief_pharmacist'),
                t('pharmacy-sites::stepper.title.technician_details'),
                t('pharmacy-sites::stepper.title.out_hours'),
            ],
            sections: [
                { component: 'pharmacy-site-main-details', isValid: !!this.id },
                { component: 'pharmacy-site-chief-pharmacist', isValid: !!this.id },
                { component: 'pharmacy-site-technician-details', isValid: !!this.id },
                { component: 'pharmacy-site-out-hours', isValid: !!this.id },
            ],
            section: 1,
            loading: true,
            tabsErrors: {
                0: [
                    'site_name',
                    'is_registered',
                    'address',
                    'post_code',
                    'phone',
                    'fax',
                    'email',
                    'pharmacy_group',
                    'blood_providers',
                    'blood_result_providers',
                ],
                1: [
                    'chief_pharmacist_name',
                    'chief_pharmacist_phone',
                    'chief_pharmacist_fax',
                    'chief_pharmacist_email',
                    'chief_pharmacist_rpsgb_number',
                ],
                2: [
                    'technician_name',
                    'technician_phone',
                    'technician_fax',
                    'technician_email',
                    'technician_rpsgb_number',
                ],
                3: [
                    'out_of_hours_contact_name',
                    'out_of_hours_contact_phone',
                    'out_of_hours_contact_fax',
                    'out_of_hours_contact_email',
                ],
            },
        };
    },
    computed: {
        errorsInTabs() {
            const errors = this.$store.state.pharmacy_sites.errorMessages.pharmacy_site;
            const Errors = [];
            const errorsInTabs = [];
            Object.keys(errors).forEach((val) => {
                if (errors[val] && errors[val].length) {
                    Errors.push(val);
                }
            });
            Object.keys(this.tabsErrors).forEach((tab) => {
                Object.values(this.tabsErrors[tab]).forEach((error) => {
                    if (Errors.includes(error)) {
                        errorsInTabs.push(tab);
                    }
                });
            });
            return _.sortedUniq(errorsInTabs);
        },
        pharmacySiteErrorMessages() {
            return this.$store.state.pharmacy_sites.errorMessages.pharmacy_site;
        },
        isFormsValid() {
            return !!this.sections.find((x) => !x.isValid);
        },
        pageTitle() {
            if (!can('pharmacy-sites.create')) {
                return 'Preview Pharmacy Site';
            }

            return this.id
                ? t('pharmacy-sites::page.title.edit_pharmacy_sites')
                : t('pharmacy-sites::page.title.new_pharmacy_sites');
        },
    },
    created() {
        this.loadPharmacySite();
    },
    methods: {
        backToList() {
            return this.$root.goTo(route('pharmacy-sites.index'));
        },
        loadPharmacySite() {
            if (_.isEmpty(this.id)) {
                this.loading = false;
                this.$store.dispatch('pharmacy_sites/loadPharmacyOptions');
                this.$store.dispatch('pharmacy_sites/loadBloodProvidersOptions');
                return;
            }

            axios
                .get(
                    route('api.v1.pharmacy-sites.show', {
                        pharmacy_site: this.id,
                        fields: '*,pharmacy_groups,blood_result_providers.id',
                    })
                )
                .then((response) => {
                    const data = response.data.data;

                    this.$store.dispatch('pharmacy_sites/loadPharmacySite', data);
                    this.$store.dispatch('pharmacy_sites/loadPharmacyOptions');
                    this.$store.dispatch('pharmacy_sites/loadBloodProvidersOptions', {
                        indclude: data.blood_result_providers,
                    });
                })
                .catch((error) => {
                    this.$root.notify('error', error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
